import { useEffect, useRef } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { animate } from "animejs";
import Homepage from "./pages/homepage";
import About from "./pages/about";
import Projects from "./pages/projects";
import Experience from "./pages/experience";
import Hobbies from "./pages/hobbies";
import NavBar from "./components/common/navBar";
import "./app.css";

function RouteFade({ children }) {
	const ref = useRef(null);
	const location = useLocation();
	useEffect(() => {
		const el = ref.current;
		if (!el) return;
		animate(el, {
			opacity: [0, 1],
			translateY: [10, 0],
			duration: 280,
			ease: "outQuad",
		});
	}, [location.pathname]);
	return (
		<div ref={ref} className="route-fade">
			{children}
		</div>
	);
}

function useActiveNav() {
	const { pathname } = useLocation();
	if (pathname === "/") return "home";
	if (pathname.startsWith("/experience")) return "experience";
	if (pathname.startsWith("/projects")) return "projects";
	if (pathname.startsWith("/hobbies")) return "hobbies";
	if (pathname.startsWith("/about")) return "about";
	return "";
}

function App() {
	const active = useActiveNav();
	return (
		<div className="App">
			<NavBar active={active} />
			<RouteFade>
				<Routes>
					<Route path="/" element={<Homepage />} />
					<Route path="/about" element={<About />} />
					<Route path="/projects" element={<Projects />} />
					<Route path="/experience" element={<Experience />} />
					<Route path="/hobbies" element={<Hobbies />} />
				</Routes>
			</RouteFade>
		</div>
	);
}

export default App;
